import { defineComponent, onMounted, reactive, ref } from 'vue'
import styles from '../styles/proxy.module.scss';
import { useRoute } from 'vue-router'
import ApiList from '../components/ApiList'
import ApiInfo from '../components/ApiInfo'
declare const io: any;
const Proxy = defineComponent(() => {
    const route = useRoute();
    const list = ref<any>([
        {url:'/ffawdawd'},
        {url:'/ffawdawd'},
        {url:'/ffawdawd'},
    ]);
    const result = ref<any>({});
    onMounted(() => {
        var socket = io.connect('http://127.0.0.1:1025', {
            query: `key=${route.params.key}`
        });
        socket.on('message',function(data: any){
            if (data.type == 'http') {
                list.value.push(data.data)
            }
            console.log(list.value);
        })
    })

    return () => <div class={styles.container} style='display:flex;'>
        <ApiList list={list.value} onChange={(v: any) => {
            result.value = v;
        }} />
        <div style='flex: 1'>
            <ApiInfo data={result.value} />

        </div>
    </div>
})

export default Proxy;